import React, { useEffect, useRef } from "react";
import type { ComputedLayoutTopology } from "interfaces/product/topology/interactiveLayer.types";
import { drawStaticElements } from "./drawStaticElements";
import { loadSprite } from "./spriteLoader";

type StaticLayoutRendererProps = {
  layout: ComputedLayoutTopology;
  isPrint?: boolean;
};

export const StaticLayoutRenderer = React.memo(
  ({ layout, isPrint }: StaticLayoutRendererProps) => {
    const canvasRef = useRef<SVGSVGElement>(null);

    useEffect(() => {
      if (!canvasRef.current) {
        return;
      }
      const canvas = canvasRef.current;
      let cancelled = false;

      loadSprite().then(() => {
        if (cancelled) return;
        canvas.innerHTML = "";
        drawStaticElements({ canvas, layout, isPrint });
      });

      return () => {
        cancelled = true;
      };
    }, [layout, isPrint]);

    return (
      <svg
        id="printTopologyId"
        ref={canvasRef}
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        className="position-relative overflow-visible"
      />
    );
  },
);
